<template>
  <div id="todo">
    <nav-bar>
      <span v-if="todoCount" slot="center">看着那么多的待办没做，难道你💕不会痛吗</span>
      <span  v-else slot="center">加油，今日事今日毕♥</span>
    </nav-bar>
    <task-bar>
      <span slot="tagging" v-if="todoCount">算下来，你已经有<span style="color: #FF0000">{{todoCount}}</span>件事拖着没干啦</span>
      <span slot="tagging" v-else>很棒，没有留下未完成待办</span>
      <list-item 
        v-for="(item, index) in myNoTodo" 
        :item="item.title"
        :done="item.done"
        :key="index"
        @deleteItem="deleteItem(index)"
        @isDone="toDo(index)">
        <span class="done" slot="left">今天完成它</span>
      </list-item>
    </task-bar>
  </div>
</template>

<script>
  import NavBar from "components/common/navbar/NavBar.vue"
  import TaskBar from "components/content/taskbar/TaskBar.vue"
  import ListItem from "components/content/listItem/ListItem.vue"

  import {getData, saveData, deleteData, getDateStr} from "assets/js/todoList.js"  

  export default {
    name: "Todo",
    components: {
      NavBar,
      TaskBar,
      ListItem,
    },
    data() {
      return {
        myNoTodo: [          
          // {title: '🍎吃苹果', done: false, createDate: "2021-03-26"},
          // {title: '🍓吃草莓', done: false, createDate: "2021-03-26"},
          // {title: '🍌吃香蕉', done: false, createDate: "2021-03-26"},
          // {title: '🍈吃橘子', done: false, createDate: "2021-03-26"},
          // {title: '🍉吃西瓜', done: false, createDate: "2021-03-26"},
          ],
        dateNow: "",
      }
    },
    computed: {
      //未完成数量
      todoCount() {
        return this.myNoTodo.filter(item => {
          return !item.done
        }).length
      },
    },
    // 页面加载即渲染所有数据并且得到当前日期
    created() {
      let allList = getData("myNoTodo")
      this.myNoTodo = allList
      this.dateNow = getDateStr()
    },
    watch: {
      myNoTodo: {
        handler() {
          saveData(this.myNoTodo,"myNoTodo")          
        },
        deep: true //深监听
      }
    },
    methods: {
      deleteItem(index) {
        this.myNoTodo.splice(index, 1)
      },
      toDo(index) {
        let myDay = getData("myday")

        this.myNoTodo[index].createDate = this.dateNow
        myDay.push(this.myNoTodo[index])
        saveData(myDay, "myday")
        this.myNoTodo.splice(index,1)
      }
    }
  }
</script>

<style scoped lang="less">
  #todo .done {
    // display: inline;
    margin-left: 0.1875rem;
    padding: 0 0.05rem 0;
    color: #fff;
    border: none;
    border-radius: 5px;
    text-decoration: none;
    cursor: pointer;
    font-size: 0.1125rem;
    
    border-radius: 26px;
    background: #448BFB;
    box-shadow: 2px 2px 2px #0341a5, -2px -2px 6px #fff;

    margin-right: 0.1875rem;

    &:hover {
      background-color: #2A61B9;

    }
    &:focus {
        border: 0 none;
        outline: none;
        box-shadow: 0;
    }
  }
</style>